import React, { CSSProperties } from "react"
import autobind from "class-autobind"
import DoubleField from "./DoubleField"
import strings from "../../localization/strings"
interface IProps {
    readonly?: boolean
    label: string
    percent: number
    maxPercent?: number
    minPercent?: number
    style?: CSSProperties
    handleChange(percent: number, error: boolean): void
}
interface IState {
    percent: string
    error: string
}

export default class PercentField extends React.Component<IProps, IState> {
    private maxPercent
    private minPercent
    constructor(props: IProps) {
        super(props)
        this.state = {
            percent: props.percent ? props.percent.toString() : "0",
            error: ""
        }
        autobind(this)
        this.maxPercent = props.maxPercent ? props.maxPercent : 100
        this.minPercent = props.minPercent ? props.minPercent : 0
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.props.percent !== nextProps.percent &&
            this.setState({ percent: nextProps.percent === null ? "" : nextProps.percent.toString() })
    }

    checkValidate() {
        const percent = parseFloat(this.state.percent)
        const isValid = percent <= this.maxPercent && percent >= this.minPercent
        this.setState({
            error: isValid ?
                "" :
                strings.formatString(strings.This_field_requires_a_number_between_min_and_max, this.minPercent, this.maxPercent) as string
        })
        return isValid
    }

    render() {
        return (
            <div style={{ display: "flex", alignItems: "baseline" }}>
                <DoubleField
                    data-intercom-target={`PercentField-Entry-${this.props.label}`}
                    readonly={this.props.readonly}
                    label={this.props.label}
                    value={this.state.percent}
                    error={this.state.error}
                    handleChange={percent => this.setState({ percent }, () => {
                        const isValid = this.checkValidate()
                        this.props.handleChange(parseFloat(this.state.percent), !isValid)
                    })}
                    style={this.props.style}
                />
                <div>%</div>
            </div>
        )
    }
}